import * as React from 'react';

import type {ConstantContactContactTrackingActivityType} from 'nutshell-graphql-types';
import type {CtCtActivity as CtCtActivityFragment} from 'nutshell-graphql-types';

type Props = {
    activity: CtCtActivityFragment | null | undefined;
    entityName: string;
};

export function ConstantContactActivity({activity, entityName}: Props) {
    if (!activity) {
        return <i>{`${entityName} has no Constant Contact history`}</i>;
    }

    const verb = getVerbFromTrackingActivityType(activity.trackingActivityType);

    const subject =
        activity.trackingActivityType === 'OPTOUTS'
            ? activity.campaignName || 'a campaign'
            : activity.subject || activity.campaignName || 'an email';

    return `${entityName} ${verb} ${subject}`;
}

function getVerbFromTrackingActivityType(type: ConstantContactContactTrackingActivityType): string {
    // These match the types in `ConstantContact_ContactTrackingActivity`, and the
    // verbs match those in public/include/js/views/ribbons.js
    switch (type) {
        case 'SENDS':
            return 'was sent';
        case 'OPENS':
            return 'opened';
        case 'BOUNCES':
            return 'had an email bounce:';
        case 'OPTOUTS':
            return 'unsubscribed from';
        case 'FORWARDS':
            return 'forwarded';
        case 'CLICKS':
            return 'clicked';
        default: {
            return 'interacted with';
        }
    }
}
